export default class Game {
  static get STATE_DRAFT() { return 'draft' }
  static get STATE_WAITING_FOR_PLAYERS() { return 'waitingForPlayers' }
}
